const updates = [
  "2026/09/08 · 早年言论补档 · 新入库 3 卷旧访谈",
  "2026/09/07 · 考古发现 · 「同台旧怨」第 2 回拼出完整时间线",
  "2026/09/05 · 陈年往事 · 补进 2014 年后台花絮两则",
  "2026/09/03 · 黑历史后续 · 早年代言翻车当事人旧回应已归档",
  "2026/08/30 · 历史旧账 · 分卷号 031 校对完毕",
  "2026/08/27 · 早年言论 · 新增语录卷「十年前那句狠话」",
];

export default function UpdateStrip() {
  return (
    <div className="bg-[#1a160e] text-[#f3ead8]">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex items-center gap-3 py-2.5 text-[11px] md:text-xs tracking-wide">
          <span className="flex items-center gap-1.5 whitespace-nowrap text-[#f0b18a]">
            <i className="ri-refresh-line text-sm" aria-hidden="true"></i>
            <span className="font-medium">归档更新条</span>
          </span>
          <span className="hidden h-3.5 w-px bg-white/20 sm:block" aria-hidden="true"></span>
          <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden whitespace-nowrap text-[#c7bda5]">
            <span className="inline-flex h-1.5 w-1.5 shrink-0 rounded-full bg-[#d6552f] motion-safe:animate-pulse" aria-hidden="true"></span>
            <span className="truncate">{updates[0]}</span>
            <span className="hidden text-[#6a5f4b] md:inline">/</span>
            <span className="hidden truncate text-[#c7bda5] md:inline">{updates[1]}</span>
            <span className="hidden text-[#6a5f4b] lg:inline">/</span>
            <span className="hidden truncate text-[#c7bda5] lg:inline">{updates[3]}</span>
          </div>
          <button
            type="button"
            className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap border border-white/15 px-2.5 py-1 text-[#efe6d2] transition hover:border-[#d6552f] hover:text-[#f0b18a]"
          >
            <i className="ri-arrow-right-up-line text-xs" aria-hidden="true"></i>
            全部更新
          </button>
        </div>
      </div>
    </div>
  );
}